var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, nothing } from 'lit';
import { GGOBaseComponent } from '../ggo.base.component.js';
import { customElement } from 'lit/decorators.js';
let KPIAccordeonComponent = class KPIAccordeonComponent extends GGOBaseComponent {
    static { this.properties = {
        sections: { type: Object },
        currentSection: { type: Object },
    }; }
    static get styles() {
        return [
            ...super.styles,
            css `
        .slds-card {
          margin-bottom: 0.75rem;
        }
        .slds-card__header {
          align-items: center;
          border-top-left-radius: 0.25rem;
          border-top-right-radius: 0.25rem;
          overflow: hidden;
          margin-bottom: 0;
          padding: 0.875rem;
        }
        .slds-card:has(.ggo-header-selected) {
          box-shadow: 0 0 1px 1px #1b96ff;
        }
        .ggo-header-selected {
          background: #f8f9fa;
          border-bottom: solid 1px#d5d5d5;
        }
        .ggo-header-not-selected {
          color: black;
          cursor: pointer;
        }
        .ggo-header-disabled {
          color: #aeaeae;
        }
        .ggo-kpi-col {
          width: 100%;
        }
        .ggo-kpi-header {
          border-left: 1px solid #aeaeae;
          width: 200px;
          text-align: right;
        }
        .ggo-kpi-header > span {
          padding: 0 0.5rem;
          border-radius: 1rem;
          color: #0176d3;
          font-weight: 600;
        }
        .ggo-header-disabled > .slds-media > .ggo-kpi-header > span {
          color: #aeaeae;
          filter: blur(0.2rem);
        }
      `,
        ];
    }
    render() {
        if (!this.currentSection && this.sections?.length > 0) {
            const firstSection = this.sections[0];
            if (!firstSection.switch || firstSection.switch.checked) {
                this.currentSection = this.sections[0];
            }
        }
        return html `
      ${this.sections.map((section) => {
            return html ` <div class="slds-grid slds-wrap">
          <div class="slds-col ggo-kpi-col">${this.renderKPI(section)}</div>
        </div>`;
        })}
    </div>`;
    }
    onSectionSelected(kpi) {
        if (kpi.switch && !kpi.switch.checked) {
            console.warn('Switch is off');
            return;
        }
        this.currentSection = kpi;
        this.dispatchEvent(new CustomEvent('changed', { detail: kpi }));
    }
    async onToggleChanged(kpi, toggleChecked) {
        if (kpi.switch) {
            const originalState = kpi.switch.checked;
            try {
                kpi.switch.checked = await kpi.switch.callback(toggleChecked);
            }
            catch (error) {
                kpi.switch.checked = originalState;
                console.error('Error toggling KPI switch:', error);
            }
            if (this.currentSection === kpi) {
                this.currentSection = this.sections[0];
            }
            this.requestUpdate();
        }
    }
    renderKPI(kpi) {
        const isSelected = this.currentSection?.label === kpi.label;
        let mainClass = isSelected ? 'ggo-header-selected' : 'ggo-header-not-selected';
        if (kpi.switch && !kpi.switch.checked) {
            mainClass = 'ggo-header-disabled';
        }
        if (kpi.switch)
            console.log('Render tab with switch', kpi.switch.checked);
        if (isSelected && kpi.update && (!kpi.switch || kpi.switch.checked)) {
            kpi.update();
        }
        return html `
      <article class="slds-card">
        <div
          @click="${() => {
            this.onSectionSelected(kpi);
        }}"
          class="slds-card__header slds-grid ${mainClass}"
        >
          <header class="slds-media slds-media_center slds-has-flexi-truncate">
            <div class="slds-media__figure">
              <input type="radio" .checked=${isSelected} />
            </div>
            <div class="slds-media__body">
              <h2 class="slds-card__header-title" style="display: flex; justify-content: space-between; align-items: center;">
                ${kpi.label}
                ${kpi.switch
            ? html `<ggo-toggle
                      title="${kpi.switch.tooltip}"
                      .checked="${kpi.switch.checked}"
                      @changed="${(e) => {
                e.stopPropagation();
                this.onToggleChanged(kpi, e.detail);
            }}"
                      @click="${(e) => e.stopPropagation()}"
                    ></ggo-toggle>`
            : nothing}
              </h2>
            </div>
            <div class="slds-no-flex ggo-kpi-header">
              <span>${kpi.value}</span>
            </div>
          </header>
        </div>
        <div class="slds-card__body slds-card__body_inner">${isSelected ? kpi.content : nothing}</div>
        <footer class="slds-card__footer"></footer>
      </article>
    `;
    }
};
KPIAccordeonComponent = __decorate([
    customElement('ggo-kpi-accordeon')
], KPIAccordeonComponent);
export { KPIAccordeonComponent };
